import { Box } from "@mui/material";

import { ATSProvider } from "../atsModule/context/ATSContext";
import OrgChart from "../atsModule/pages/OrgChart";

// The org chart, hosted inside the Daily Tick shell.
//
// Same component the ATS module routes at /ats/org and /ats/departments/:deptId.
// It is mounted a second time here so that drilling into a department from this
// shell's Departments screen stays in this shell — see DepartmentsHub and
// atsModule/components/departments/deptRoutes.js, which is what keeps the links
// inside it pointing back here rather than at /ats.
//
// ATSProvider is the only piece of the ATS shell that is needed: it reads
// store_id and user_id off the login already in AutoTaskAuthContext.

const DepartmentOrgChart = () => (
  <Box sx={{ p: { xs: 1.5, sm: 2.5 } }}>
    <ATSProvider>
      <OrgChart />
    </ATSProvider>
  </Box>
);

export default DepartmentOrgChart;
